import { ReactNode } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { MissingPlayerReasonAreaIds } from '@common/types'

import { getPrettyClass } from '@/utils/getPrettyClass'

interface SortableItemProps {
    id: string | number
    children: ReactNode
    data: any
    itemKey: string
}
export function SortableItem({ id, children, data, itemKey }: SortableItemProps) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, data })

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : undefined,
    }

    const getClassName = () => getPrettyClass(`${MissingPlayerReasonAreaIds[data.player?.reason]}-${itemKey}`)

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={getClassName()}>
            {children}
        </div>
    )
}
